package app.properties

class DocumentType(
        val id: String? = null,
        val name: String
)
